(() => {
  if (window.akonConfiguratorLoaded) return;
  window.akonConfiguratorLoaded = true;
  const copy = JSON.parse(document.getElementById('akon-configurator-copy').textContent);
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const families = [
    { root: 'banco (reclinable o plano)', matches: /banco/, label: copy.bank },
    { root: 'pack de discos bumper o discos agarre', matches: /discos|bumper/, label: copy.discs },
    { root: 'cierre', matches: /cierre|bloqueador/, label: copy.collars }
  ];
  const selected = (option) => [...option.querySelectorAll('input:checked:not(:disabled), select:not(:disabled) option:checked:not(:disabled)')]
    .filter((input) => input.value && input.value !== '-1');
  const title = (option) => option.querySelector('.bold_option_title')?.textContent.trim() || '';
  const visible = (option) => option.getClientRects().length && getComputedStyle(option).visibility !== 'hidden';
  function note(parent, className, text, before) {
    let el = parent.querySelector(`:scope > .${className}`);
    if (!el) {
      el = document.createElement('p');
      el.className = className;
      parent.insertBefore(el, before || null);
    }
    el.textContent = text;
    return el;
  }
  function update(root) {
    const options = [...root.querySelectorAll('.bold_option')].filter((option) => title(option) && visible(option));
    root.querySelectorAll('.akon-option-pending, .akon-option-group, .akon-option-required').forEach((el) => el.remove());
    const required = options.filter((option) => /\*\s*$/.test(title(option)));
    required.forEach((option) => note(option, 'akon-option-required', copy.required));
    const optional = options.find((option) => !required.includes(option));
    if (required.length) note(required[0], 'akon-option-group', copy.requiredGroup, required[0].firstChild);
    if (optional && required.length) note(optional, 'akon-option-group', copy.optionalGroup, optional.firstChild);
    for (const family of families) {
      const parent = options.find((option) => normalize(title(option)) === family.root);
      if (!parent || !selected(parent).length) continue;
      const group = options.filter((option) => family.matches.test(normalize(title(option))));
      const complete = group.some((option) => selected(option).some((input) => input.dataset.productHandle));
      if (complete) continue;
      const unfinished = group.find((option) => option !== parent && !selected(option).length) || parent;
      note(unfinished, 'akon-option-pending', copy.unfinished.replace('[option]', title(unfinished)));
    }
    const scope = root.closest('.product-info') || root.closest('.shopify-section');
    if (!scope) return;
    if (scope.querySelector('.akon-configurator-error')) showRequired(root, false);
  }
  function showRequired(root, focus) {
    const missing = [...root.querySelectorAll('.bold_option')].filter((option) => visible(option) && /\*\s*$/.test(title(option)) && !selected(option).length);
    const scope = root.closest('.product-info') || root.closest('.shopify-section');
    if (!scope) return false;
    let error = scope.querySelector('.akon-configurator-error');
    if (!missing.length) { error?.remove(); return false; }
    if (!error) {
      error = document.createElement('p');
      error.className = 'akon-configurator-error';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      const form = scope.querySelector('form[action*="/cart/add"]');
      (form || scope).prepend(error);
    }
    error.textContent = copy.missing.replace('[options]', missing.map((option) => title(option).replace(/\*\s*$/, '')).join(', '));
    if (focus) { error.focus({ preventScroll: true }); error.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return true;
  }
  let scheduled = false;
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.target.closest?.('.bold_options') || [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches('.bold_options') || node.querySelector('.bold_options'))))) schedule();
  });
  function refresh() {
    observer.disconnect();
    document.querySelectorAll('.product-info .bold_options, .cc-main-product .bold_options').forEach(update);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'checked'] });
    scheduled = false;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="add"], input[name="add"]');
    if (!button) return;
    const scope = button.closest('.product-info') || button.closest('.shopify-section');
    const root = scope?.querySelector('.bold_options');
    if (!root) return;
    refresh();
    if (showRequired(root, true)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    const root = event.target.closest('.product-info')?.querySelector('.bold_options');
    if (!root) return;
    refresh();
    if (showRequired(root, true)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  refresh();
})();
